import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ExploreIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <title>Explore</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#979797'}
          d="M21.72 19.015l-4.18-4.18a9.5
          9.5 0 0 0 1.59-5.27C19.13 4.291
          14.84 0 9.566 0 4.291 0 0 4.291 0
          9.565c0 5.275 4.291 9.566 9.565
          9.566a9.5 9.5 0 0 0 5.27-1.591l4.179
          4.18a.955.955 0 0 0 1.352 0l1.353-1.353a.955.955 0 0 0
          .001-1.352zM1.913 9.565c0-4.219 3.433-7.652
          7.652-7.652 4.22 0 7.653 3.433 7.653 7.652 0 4.22-3.433
          7.653-7.653 7.653-4.219 0-7.652-3.433-7.652-7.653z" />
      </svg>
    );
  }
}

ExploreIcon.propTypes = {
  active: PropTypes.bool
};
